<template>
  <div v-if="disabled" class="ql-container ql-snow">
    <div class="ql-editor" v-html="value" ></div>
  </div>
  <div class="rich-text" v-else>
    <div ref="richDOM"></div>
  </div>
</template>
<script>
import Quill from 'quill'
import 'quill/dist/quill.snow.css'
export default {
  name: 'RichText',
  props: ['value', 'disabled', 'placeholder'],
  data() {
    return {
      richtext: null,
    }
  },
  mounted() {
    const quillOptions = {
      theme: 'snow',
      placeholder: this.placeholder,
      modules: {
        toolbar: {
          container: [
            'bold',
            'italic',
            'underline',
            'strike',
            { list: 'ordered' },
            { list: 'bullet' },
            { color: [] },
            { background: [] },
            { size: [false, 'small', 'large', 'huge'] },
            'clean',
            'image',
          ],
          handlers: {
            image: (value) => {
              if (value) {
                let inputDOM = document.querySelector('input.ql-image')
                if (!inputDOM) {
                  inputDOM = document.createElement('input')
                  inputDOM.type = 'file'
                  inputDOM.accept = 'image/png, image/gif, image/jpeg'
                  inputDOM.classList.add('ql-image')
                  inputDOM.style.display = 'none'
                  inputDOM.addEventListener('change', (e) => {
                    const formDate = new FormData()
                    formDate.append(
                      'folder',
                      `/goods/info/${this.$dayjs().format('YYYYMMDD')}`
                    )
                    formDate.append('file', e.target.files[0])
                    this.$axios
                      .post('/funs/upload/image', formDate)
                      .then((data) => {
                        const range = this.richtext.getSelection(true)
                        this.richtext.insertEmbed(
                          range.index,
                          'image',
                          this.$envConst.IMAGE_ORIGIN + data
                        )
                        this.richtext.setSelection(range.index + 1)
                        inputDOM.value = ''
                      })
                  })
                  document.querySelector('.ql-toolbar').append(inputDOM)
                }
                inputDOM.click()
              }
            },
          },
        },
      },
    }
    this.richtext = new Quill(this.$refs.richDOM, quillOptions)
    this.richtext.on(
      'editor-change',
      this.$_.debounce(() => {
        this.$emit('input', this.richtext.root.innerHTML)
      }, 800)
    )
    if (this.value) {
      this.richtext.root.innerHTML = this.value
    }
  },
  methods: {
    // htmlDecode(str) {
    //   var t = document.createElement('div')
    //   t.innerHTML = str
    //   return t.innerText || t.textContent
    // },
  },
}
</script>
<style lang="stylus" scoped>
.rich-text
  &.disabled::before
    content: ''
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 100%
    background: rgba(#ddd, 0.5)
    z-index: 5
    cursor: not-allowed
</style>
